import React from 'react'
import { Grid, Button, Typography, FormControl, FormHelperText } from '@material-ui/core'
import PlusLoadQuantityInput from '../comps/PlusLoadQuantityInput'
import Alert from '../comps/Alert'
import cn from 'classnames'

export function getPlusLoadConfirmTitle() {
  return `Confirm Plus Load`
}
export function getPlusLoadConfirmContent(options: { classes: any, quantity: number, currentOrderQuantity: number }) {
  const { classes, quantity, currentOrderQuantity } = options
  return (
    <React.Fragment>
      <Typography variant='body1' className={cn(classes.marginTop2unit, classes.marginBottom2unit)}>
        { `Confirm and submit your plus load.` }
      </Typography>
      <div className={classes.quantityConfirming}>
        { `+ ${quantity} m³` }
      </div>
      <div className={cn(classes.marginTop2unit, classes.marginBottom2unit)}>
        <Typography variant='body1' className={cn(classes.displayInline)} component='span'>
          { `The new total for this order including this plus load will be` }
        </Typography>
        <Typography variant='body1' className={cn(classes.displayInline, classes.fontWeight500)} component='span'>
          { ` ${(quantity + currentOrderQuantity).toFixed(1)} m³ ` }
        </Typography>
        <Typography variant='body1' className={cn(classes.displayInline)} component='span'>
          { `.` }
        </Typography>
      </div>
      <Typography variant='body1' className={cn(classes.marginTop2unit, classes.marginBottom2unit)}>
        { `This change in quantity may incur additional charges.` }
      </Typography>
    </React.Fragment>
  )
}

export function getPlusLoadConfirmFooter(options: { classes: any, onBack: () => void, onSubmit: () => void, isQuantityValid: boolean}) {
  const { classes, onBack, onSubmit, isQuantityValid } = options
  return (
    <Grid className={classes.textAlignRight} container justify='flex-end' spacing={2}>
      <Grid className={classes.flexGrow1} item>
        <Button className={classes.button} onClick={onBack} variant='outlined'>
          { `Back` }
        </Button>
      </Grid>
      <Grid item>
        <Button
          className={classes.button}
          color='primary'
          onClick={onSubmit}
          variant='contained'
          disabled={!isQuantityValid}
        >
          { `Submit Plus Load` }
        </Button>
      </Grid>
    </Grid>
  )
}
